<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="concepts"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="concepts"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="openConcept"
        :max-width="maxWidth[0]"
        persistent
        @keydown.esc="reset(false)"
      >
        <FormConcepts
          :items="dataConcept"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsLiquidations="[dataModelsLiquidation]"
          :itemsSalaries="[dataConceptsSalary]"
          :itemsCheckbox="dataChekboxes"
          :showDate="true"
          :showCheck="true"
          :multiple="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormConcepts from "./Forms/FormConcepts.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    FormConcepts,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("concepts.concepts"),
      titleTable: "Conceptos_y_Relaciones",
      titleDelete: this.$tc("concepts.toConcept"),
      isLoading: true,
      maxWidth: ["700px", "650px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      dataConcept: [
        {
          name: "name",
          label: this.$tc("concepts.nameConcept"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("concepts.rulesDataConcept"),
          ],
        },
      ],
      dataChekboxes: [
        {
          name: "fullDayLicense",
          label: this.$tc("concepts.fullDayLicense"),
          data: false,
        },
        {
          name: "workHours",
          label: this.$tc("concepts.hoursWorked"),
          data: false,
        },
        {
          name: "roundSalary",
          label: this.$tc("concepts.roundOffLiquidations"),
          data: false,
        },
        {
          name: "denyAccess",
          label: this.$tc("concepts.denyAccess"),
          data: false,
        },
      ],
      headers: {
        conceptos: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Licencia de día",
            value: "fullDayLicenseTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Horario trabajado",
            value: "workHoursTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Redondea",
            value: "roundSalaryTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        liquidaciones: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Autoriza",
            value: "auth",
            class: "primary secondary--text",
            visible: true,
          },

          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        salarios: [
          {
            text: "Nombre",
            value: "nombre",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "fecDesde",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "fecHasta",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          Object.values(this.allColums).reduce(
            (sum, array) => sum + array.length,
            0
          ) !==
            Object.values(this.headers).reduce(
              (sum, array) => sum + array.length,
              0
            )
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    try {
      await Promise.all([
        concepts.dispatch("getConcepts"),
        concepts.dispatch("getLiquidationModels"),
        concepts.dispatch("getSalaries"),
        // config.dispatch("getColumsTableName", tableName),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    allHeaders() {
      return configTable.state.colums.conceptos;
    },
    allColums() {
      return configTable.state.colums;
    },
    concepts() {
      return concepts.state.concepts.map((concept) => ({
        ...concept,
        editable: [1, 2, 3, 4].includes(concept.conceptId)
          ? true
          : concept.editable,
      }));
    },
    padding() {
      return concepts.state.paddingNav;
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },
    dataConceptsSalary() {
      return {
        name: "cSueldos",
        label: this.$tc("concepts.salaryConcepts"),
        data: [],
        items: this.salaries,
        itemsValue: "id",
        itemsText: "name",
        rules: [
          (v) =>
            (v !== null && v !== undefined && v !== "") ||
            this.$tc("editRegistrations.requerid"),
        ],
      };
    },
    dataModelsLiquidation() {
      return {
        autorizar: true,
        name: "liqModelos",
        label: this.$tc("concepts.modelsLiquidation"),
        data: [],
        items: this.liquidations,
        itemsValue: "liqmodelId",
        itemsText: "name",
      };
    },
    mode: {
      get() {
        return concepts.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openConcept: {
      get() {
        return concepts.state.openConcepts;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return concepts.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await concepts.dispatch("getConcepts");
    },
    updateHeaders(headers) {
      const updatedColums = { ...configTable.state.colums, conceptos: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allColums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    buildPayload(form) {
      const denyAccess = form.denyAccess;
      const roundSalary = form.roundSalary;
      const workHours = form.workHours === true ? "S" : "N";
      const fullDayLicense = form.fullDayLicense === true ? "S" : "N";

      const payload = {
        nombre: form.name,
        fullDayLicense: fullDayLicense,
        workHours: workHours,
        roundSalary: roundSalary,
        denyAccess: denyAccess,
      };

      if (form.cSueldos && form.cSueldos.trim() !== "") {
        const cSueldoIds = form.cSueldos.split(",");

        payload.cSueldos = cSueldoIds.map((cSueldoId) => ({
          cSueldoId: parseInt(cSueldoId),
          fecDesde: date.state.dateFrom,
          fecHasta: date.state.dateTo,
        }));
      }
      if (form.liqModelos && form.liqModelos.trim() !== "") {
        const liquidationsIds = form.liqModelos.split(",");
        payload.liqModelos = liquidationsIds.map((modelo) => ({
          liqModeloId: modelo,
          autoriza: form.authAll,
        }));
      }
      return payload;
    },

    addConcept(form) {
      const payload = this.buildPayload(form);
      concepts.commit("setNewConcept", payload);

      concepts
        .dispatch("addConcept")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("concepts.addConceptAlert");
        })
        .catch((error) => {
          this.alert = true;
          this.textAlert = error.response.data.message;
          this.color = "#ff8d58";
        })
        .finally(() => {
          this.reset(false);
        });
    },

    async editConcept(form) {
      const payload = this.buildPayload(form);
      payload.conceptId = this.itemId;
      await concepts.commit("setEditConcept", payload);
      await concepts
        .dispatch("editConcept")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("concepts.editConceptAlert");
          concepts.dispatch("getConcepts");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("errorEditConceptAlert");
          this.color = "#ff8d58";
        });
      this.reset(false);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addConcept(items);
          break;
        case "edit":
          this.editConcept(items);
          break;
        default:
          break;
      }
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      concepts.commit("setOpenConcept", value);
      this.dataConcept.forEach((item) => {
        item.data = "";
      });

      this.dataConceptsSalary.data = [];

      this.dataModelsLiquidation.data = [];

      this.dataChekboxes.forEach((checkbox) => {
        checkbox.data = false;
      });
    },
    cardView(value) {
      this.showCard = value;
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          concepts.commit("setMode", this.$tc("concepts.addConcept"));
          concepts.commit("setOpenConcept", true);
          break;
        case "edit":
          this.itemId = item.conceptId;
          concepts.commit("setMode", this.$tc("concepts.editConcept"));
          await this.handleEdit(item);
          break;
        case "delete":
          concepts.commit("setOpenDelete", true);
          this.itemToDelete = item.conceptId;
          break;

        default:
          break;
      }
    },

    async handleEdit(item) {
      this.itemId = item.conceptId;
      await concepts.dispatch("getConceptId", this.itemId);
      if (concepts.state.editConcept.cSueldos) {
        concepts.state.editConcept.cSueldos =
          concepts.state.editConcept.cSueldos.map((sueldo) =>
            this.formatcSueldos(sueldo)
          );
      }

      this.formatDataConcept();
      this.formatDataCheckboxes();

      if (concepts.state.editConcept.liqModelos) {
        concepts.state.editConcept.liqModelos =
          concepts.state.editConcept.liqModelos.map((liquidation) =>
            this.formatLiquidation(liquidation)
          );
      }

      concepts.commit("setOpenConcept", true);
    },

    formatcSueldos(originalObject) {
      return {
        cSueldoId: originalObject.cSueldoId,
        nombre: originalObject.nombre,
        fecDesde: moment.utc(originalObject.fecDesde).format("DD-MM-YYYY"),
        fecHasta: originalObject.fecHasta
          ? moment.utc(originalObject.fecHasta).format("DD-MM-YYYY")
          : "",
      };
    },
    formatLiquidation(originalObject) {
      return {
        id: originalObject.liqModeloId,
        name: originalObject.nombre,
        auth: originalObject.autoriza === 1 ? "✔️" : "",
      };
    },

    formatDataConcept() {
      this.dataConcept[0].data = concepts.state.editConcept.nombre;
    },

    formatDataCheckboxes() {
      this.dataChekboxes.forEach((checkbox) => {
        if (checkbox.name === "fullDayLicense") {
          checkbox.data = concepts.state.editConcept.licTot === "S";
        }
        if (checkbox.name === "workHours") {
          checkbox.data = concepts.state.editConcept.horTrab === "S";
        }
        if (checkbox.name === "roundSalary") {
          checkbox.data = concepts.state.editConcept.redondeaLiq;
        }
        if (checkbox.name === "denyAccess") {
          checkbox.data = concepts.state.editConcept.denegarAcceso;
        }
      });
    },

    async formatDatacSueldos() {
      const primerConcepto = concepts.state.editConcept.cSueldos[0];
      if (primerConcepto) {
        await date.commit("setDateFrom", primerConcepto.fecDesde);
        await date.commit("setDateTo", primerConcepto.fecHasta);
      }
      this.dataConceptsSalary.items.forEach((concepto) => {
        const existsInEditConcept = concepts.state.editConcept.cSueldos.some(
          (item) => item.nombre === concepto.name
        );
        concepto.data = existsInEditConcept;
      });
    },

    deleteItem() {
      concepts.commit("setItemDelete", this.itemToDelete);
      concepts
        .dispatch("deleteConcept")
        .then(() => {
          this.openDelete = false;
          concepts.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc("concepts.deleteConceptAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("concepts.errorDeleteConceptAlert");
          this.color = "#ff8d58";
        });
    },

    cancelDelete() {
      this.openDelete = false;
      concepts.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
